import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
export default {
  __name: 'ContractStatus',
  props: {
    settlementState: {
      type: Number
    }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      const _component_el_tag = _resolveComponent("el-tag");
      return _openBlock(), _createElementBlock("span", null, [__props.settlementState === 0 ? (_openBlock(), _createBlock(_component_el_tag, {
        key: 0,
        type: "success"
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode("审核通过", -1)]))]),
        _: 1
      })) : __props.settlementState === 2 ? (_openBlock(), _createBlock(_component_el_tag, {
        key: 1,
        type: "warning"
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("待审核", -1)]))]),
        _: 1
      })) : __props.settlementState === 1 ? (_openBlock(), _createBlock(_component_el_tag, {
        key: 2,
        type: "danger"
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode("审核未通过", -1)]))]),
        _: 1
      })) : __props.settlementState === 4 ? (_openBlock(), _createBlock(_component_el_tag, {
        key: 3,
        type: "success"
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode("已报账", -1)]))]),
        _: 1
      })) : __props.settlementState === 9 ? (_openBlock(), _createBlock(_component_el_tag, {
        key: 4,
        type: "success"
      }, {
        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("已归档", -1)]))]),
        _: 1
      })) : (_openBlock(), _createBlock(_component_el_tag, {
        key: 5,
        type: "info"
      }, {
        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("待提交", -1)]))]),
        _: 1
      }))]);
    };
  }
};